import { FilterValue } from "../Filters/FilterValue";

export enum PurchaseRequestApprovalTeam {
  SOURCING = "sourcing",
  FINANCE = "finance",
  SWAGEAZY = "swageazy",
}

export type PurchaseRequestPendingApprovalType =
  `${PurchaseRequestApprovalTeam}_pending`;
export type PurchaseRequestApprovedType =
  `${PurchaseRequestApprovalTeam}_approved`;

const PURCHASE_REQUEST_APPROVAL_TEAMS: PurchaseRequestApprovalTeam[] = [
  PurchaseRequestApprovalTeam.SOURCING,
  PurchaseRequestApprovalTeam.FINANCE,
  PurchaseRequestApprovalTeam.SWAGEAZY,
];

const buildApprovalOptions = (
  suffix: "pending" | "approved",
): FilterValue[] =>
  PURCHASE_REQUEST_APPROVAL_TEAMS.map((team) => ({
    id: `${team}_${suffix}`,
    value: `${team.charAt(0).toUpperCase()}${team.slice(1)} ${
      suffix.charAt(0).toUpperCase() + suffix.slice(1)
    }`,
  }));

export const PURCHASE_REQUEST_PENDING_APPROVAL_OPTIONS =
  buildApprovalOptions("pending");
export const PURCHASE_REQUEST_APPROVED_OPTIONS = buildApprovalOptions("approved");

export const parsePurchaseRequestPendingApprovalTypes = (
  value: string | null,
): PurchaseRequestPendingApprovalType[] => {
  if (!value) return [];

  const validTypes = new Set(
    PURCHASE_REQUEST_APPROVAL_TEAMS.map(
      (team) => `${team}_pending` as PurchaseRequestPendingApprovalType,
    ),
  );

  return value
    .split(",")
    .map((item) => item.trim())
    .filter(
      (item): item is PurchaseRequestPendingApprovalType => validTypes.has(item as PurchaseRequestPendingApprovalType),
    );
};

export const parsePurchaseRequestApprovedTypes = (
  value: string | null,
): PurchaseRequestApprovedType[] => {
  if (!value) return [];

  const validTypes = new Set(
    PURCHASE_REQUEST_APPROVAL_TEAMS.map(
      (team) => `${team}_approved` as PurchaseRequestApprovedType,
    ),
  );

  return value
    .split(",")
    .map((item) => item.trim())
    .filter(
      (item): item is PurchaseRequestApprovedType => validTypes.has(item as PurchaseRequestApprovedType),
    );
};
